import {
  createStore as _createStore,
  applyMiddleware /*, compose*/
} from 'redux';
import createMiddleware from './clientMiddleware';

export default function createStore({ client, data }) {
  const middleware = [createMiddleware(client)];

  const finalCreateStore = applyMiddleware(...middleware)(_createStore);
  // let finalCreateStore;
  // if (__DEV__ && __DEVTOOLS__) {
  //   const { persistState } = require('redux-devtools');
  //   const DevTools = require('./dev-tools').default;
  //   finalCreateStore = compose(
  //     applyMiddleware(...middleware),
  //     DevTools.instrument(),
  //     persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/))
  //   )(_createStore);
  // } else {
  //   finalCreateStore = applyMiddleware(...middleware)(_createStore);
  // }

  const reducer = require('./modules/reducer').default;
  const store = finalCreateStore(reducer, data);

  if (__DEV__ && module.hot) {
    module.hot.accept('./modules/reducer', () => {
      store.replaceReducer(require('./modules/reducer').default);
    });
  }

  return store;
}
